<style scoped>
p {
  font-size: 16px;
  color: #4e4b66;
}

.vue-treeselect__control {
  padding: 1.29rem 0.75rem !important;
}
</style>


<template>
  <register-container :step="step">
      <div class="card-body">
          <h1 class="head-title font-weight-bold text-center">
              Business Detail
          </h1>
          <p class="mb-4 text-center">Short instruction about this step</p>
          <b-form
              @submit.prevent="formSubmitted"
              @keydown="form.onKeydown($event)"
          >
              <b-row>
                  <b-col cols="12" md="6" lg="6">
                      <b-form-group>
                          <template v-slot:label>
                              Company Name <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                              type="text"
                              v-model="form.company_name"
                              v-bind:class="{
                        'is-invalid': form.errors.has('company_name'),
                      }"
                          ></b-form-input>
                          <has-error :form="form" field="company_name"></has-error>
                      </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6" lg="6">
                      <b-form-group>
                          <template v-slot:label>
                              Position/Title <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                              type="text"
                              v-model="form.position"
                              v-bind:class="{
                        'is-invalid': form.errors.has('position'),
                      }"
                          ></b-form-input>
                          <has-error :form="form" field="position"></has-error>
                      </b-form-group>
                  </b-col>
              </b-row>

              <b-row>
                  <b-col cols="12" md="6" lg="6">
                      <b-form-group>
                          <template v-slot:label>
                              Company Address  <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                              type="text"
                              v-model="form.address"
                              v-bind:class="{
                        'is-invalid': form.errors.has('address'),
                      }"
                          ></b-form-input>
                          <has-error :form="form" field="address"></has-error>
                      </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6" lg="6">
                      <b-form-group>
                          <template v-slot:label>
                              Business Phone Number <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                              type="text"
                              placeholder="e.g. 04XX-XXX-XXX"
                              v-model="formattedPhone"
                              v-bind:class="{
                        'is-invalid': form.errors.has('phone'),
                      }"
                              @keyup="formatPhone"
                          ></b-form-input>
                          <has-error :form="form" field="phone"></has-error>
                      </b-form-group>
                  </b-col>
              </b-row>

              <b-row>
                  <b-col cols="12" md="6" lg="6">
                      <b-form-group>
                          <template v-slot:label>
                              ABN/ACN <span class="text-danger">*</span>
                          </template>
                          <b-form-input
                              type="text"
                              placeholder="e.g. 99-999-999-999"
                              v-model="form.abn_acn"
                              @keyup="abnNumber"
                              v-bind:class="{
                        'is-invalid': form.errors.has('abn_acn'),
                      }"
                          >
                          </b-form-input>
                          <has-error :form="form" field="abn_acn"></has-error>
                      </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6" lg="6">
                      <b-form-group>
                          <template v-slot:label>
                              Number of Employees <span class="text-danger">*</span>
                          </template>
                          <b-form-select
                              style="border-radius: 16px"
                              v-model="form.employees"
                              :options="employees"
                          ></b-form-select>
                          <has-error :form="form" field="employees"></has-error>
                      </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12" lg="12">
                      <b-form-group>
                          <template v-slot:label>
                              Category/Trade Type <span class="text-danger">*</span>
                          </template>
                          <treeselect
                              v-model="form.category_ids"
                              :multiple="true"
                              :options="categories"
                          />
                          <has-error :form="form" field="category_ids"></has-error>
                      </b-form-group>
                  </b-col>
              </b-row>

              <b-button
                  :disabled="form.busy"
                  type="submit"
                  variant="primary"
                  class="btn-grad"
                  style="float: right"
              >Next
              </b-button>
          </b-form>
      </div>
  </register-container>
</template>

<script>
import { Form, HasError } from "vform";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import SideBar from "../includes/SideBar.vue";
import FooterComponent from "../../../../pages/includes/FooterComponent.vue";
import phoneNoMixin from "../../../../mixins/phoneNoMixin.js";
import RegisterContainer from "./RegisterContainer.vue";
Vue.component(HasError.name, HasError);

export default {
  props: ["step", "sidebarListLinks"],
  components: {
      RegisterContainer,
    FooterComponent,
    Treeselect,
    SideBar,
  },
  mixins: [phoneNoMixin],
  data() {
    return {
      form: new Form({
        company_name: "",
        position: "",
        phone: "",
        abn_acn: "",
        address: "",
        employees: "",
        category_ids: [],
      }),
      formattedPhone: "",
      employees: [
        { value: "", text: "Range", disabled: false },
        { value: "1-5", text: "1 - 5" },
        { value: "5-10", text: "5 - 10" },
        { value: "10-20", text: "10 - 20" },
        { value: "20-100", text: "More than 20" },
      ],
      categories: [],
    };
  },
  mounted() {
    this.loadCategories();
    this.fetchFormData();
  },
  methods: {
    fetchFormData() {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/contractor/business/getDetails", { load_category_ids: 1 })
        .then((response) => {
          if (response.data.business) {
            this.form.fill(response.data.business);
            this.form.category_id &&
              this.loadSubCategories(this.form.category_id);
            if (response.data.business.business_phone) {
              this.formattedPhone = this.formatPhoneForAustralia(
                response.data.business.business_phone
              );
              this.form.phone = this.getPhoneDigitsOnly(this.formattedPhone);
            }
          }
          this.$root.$data.bsLoader = false;
        }).catch((err) => {
         this.$root.$data.bsLoader = false;
      });
    },
    loadCategories() {
      axios
        .post("api/content/getBusinessCategories", { load_children: 1 })
        .then((response) => {
          this.categories = response.data.categories.map((category) => {
            if (category.children.length > 0) {
              return {
                id: category.id,
                label: category.name,
                children: category.children.map((children) => {
                  return {
                    id: children.id,
                    label: children.name,
                  };
                }),
              };
            } else {
              return {
                id: category.id,
                label: category.name,
              };
            }
          });
        });
    },
    formSubmitted() {
      this.$root.$data.bsLoader = true;
      this.form.post("api/contractor/business/updateOrCreate").then(() => {
        this.$router.push({
          name: "register-contractor",
          params: { step: 3 },
          query: { step: 2 },
        });
      }).catch((err) => {
         this.$root.$data.bsLoader = false;
      });
    },
    formatPhone() {
      this.form.phone = this.getPhoneDigitsOnly(this.formattedPhone);
      this.formattedPhone = this.formatPhoneForAustralia(this.form.phone);
    },
    abnNumber() {
      this.form.abn_acn = this.getABNACNDigitsOnly(this.form.abn_acn);
    },
  },
};
</script>

